/* Move the existing, fully bound trigger, retaining its ID, listeners and
   the configurator's own focus restoration. No proxy controls or price logic. */
(function(){
  'use strict';
  function integrate(){
    var slot=document.querySelector('[data-oh-lens-trigger-slot]');
    var entry=document.getElementById('ohLensPageEntry');
    var trigger=entry&&entry.querySelector('#ohLcTrigger');
    if(!slot||!entry||!trigger)return;
    slot.replaceChildren(trigger);
    entry.hidden=true;
    /* This breadcrumb used to appear halfway down the page after its hero. */
    var section=entry.closest('.oh-lens-page-section');
    if(section)section.querySelectorAll('nav[aria-label="Breadcrumb"]').forEach(function(n){n.setAttribute('data-oh-ls-duplicate-breadcrumb','');});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',integrate,{once:true});
  else integrate();
  document.addEventListener('shopify:section:load',integrate);
})();
